import haircareSteps from '../lib/haircareQuiz';
import supplementSteps from '../lib/supplementQuiz';
import {normaliseKey} from './string';

/**
 * Subscribe user to mailchimp
 * @param {object} data
 */
const subscribeMailchimp = async (data) => {
  if (window.quizData.dbApiEndpoint === null || window.quizData.dbApiEndpoint === undefined) return false;

  const quizType = localStorage.getItem('quiz-type');
  const steps = (quizType === 'supplement') ? supplementSteps : haircareSteps;

  console.log('subscribeMailchimp data:', data); // Log the raw input data

  const body = {};

  steps.forEach((step) => {
    step.steps.forEach((subStep) => {
      const name = subStep.field.name || subStep.heading;
      const normalisedName = normaliseKey(name);

      if (normalisedName in data) {
        body[name] = data[normalisedName];
      }
    });
  });

  const email = body['emailsubcribe'];
  const tag = (quizType === 'supplement') ? 'Entered Email on PPW Quiz' : 'Entered Email on PSC Quiz';
  const tags = [tag];

  fetch(window.quizData.dbApiEndpoint + 'newsletters/subscribe', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    mode: 'cors',
    body: JSON.stringify({
      email,
      tags
    })
  });

  return true;
};

export default subscribeMailchimp;
